<script type="text/javascript">
import Vue from 'vue';
import axios from 'axios';
import app from '@/main';

const birthplaceList = [
    '北京市',
    '天津市',
    '上海市',
    '重庆市',
    '河北省',
    '山西省',
    '辽宁省',
    '吉林省',
    '黑龙江省',
    '江苏省',
    '浙江省',
    '安徽省',
    '福建省',
    '江西省',
    '山东省',
    '河南省',
    '湖北省',
    '湖南省',
    '广东省',
    '海南省',
    '四川省',
    '贵州省',
    '云南省',
    '陕西省',
    '甘肃省',
    '青海省',
    '台湾省',
    '内蒙古自治区',
    '广西壮族自治区',
    '西藏自治区',
    '宁夏回族自治区',
    '新疆维吾尔自治区',
    '香港特别行政区',
    '澳门特别行政区'
];

const nationList = [
    '汉族',
    '阿昌族',
    '白族',
    '保安族',
    '布朗族',
    '布依族',
    '朝鲜族',
    '达翰尔族',
    '傣族',
    '德昂族',
    '东乡族',
    '侗族',
    '独龙族',
    '俄罗斯族',
    '鄂伦春族',
    '鄂温克族',
    '高山族',
    '哈尼族',
    '哈萨克族',
    '赫哲族',
    '回族',
    '基诺族',
    '京族',
    '景颇族',
    '柯尔克孜族',
    '拉祜族',
    '黎族',
    '傈僳族',
    '珞巴族',
    '满族',
    '毛南族',
    '么佬族',
    '门巴族',
    '蒙古族',
    '苗族',
    '纳西族',
    '怒族',
    '普米族',
    '羌族',
    '撒拉族',
    '畲族',
    '水族',
    '塔吉克族',
    '塔塔尔族',
    '土家族',
    '土族',
    '佤族',
    '维吾尔族',
    '乌孜别克族',
    '锡伯族',
    '瑶族',
    '彝族',
    '仡佬族',
    '裕固族',
    '藏族',
    '壮族'
];

const zodiacList = ['鼠', '牛', '虎', '兔', '龙', '蛇', '马', '羊', '猴', '鸡', '狗', '猪'];
const constellationList = [
    '白羊座',
    '金牛座',
    '双子座',
    '巨蟹座',
    '狮子座',
    '处女座',
    '天秤座',
    '天蝎座',
    '射手座',
    '摩羯座',
    '水瓶座',
    '双鱼座'
];

const serviceModelList = [
    { id: 1, name: '钟点工' },
    { id: 2, name: '白班保姆' },
    { id: 3, name: '住家保姆' },
    { id: 4, name: '月嫂' },
    { id: 5, name: '代班保姆-钟点工' },
    { id: 6, name: '代班保姆-保姆' }
];
//是否需要审核
const templateNeedReview = [
  {id: 0,name: "未设定"  },
  {id: 1,name: "要审核(归档)"  },
  {id: 2,name: "不审核(自动归档)"  },
/*  {id: 2,name: "要审核且盖章(加归档)"  },
  {id: 4,name: "不审核自动盖章(加自动归档)"  }*/
];

//合同级别
const templateLevel = [
  { id: 1, name: "主合同" },
  { id: 2, name: "子合同" }
];

const templateSignOneType = [
  { id: 0, name: "无" },
  { id: 1, name: "机构" },
  { id: 2, name: "个人" },
/*  { id: 3, name: "客户" },
  { id: 4, name: "主机构盖章" }*/
];

const templateSignTwoType = [
  { id: 0, name: "没有" },
  { id: 1, name: "机构" },
  { id: 2, name: "个人" },
/*  { id: 3, name: "客户" },
  { id: 4, name: "其他" }*/
];

//contract_template_field.type
const templateKeyType = [
  { id: 1, name: "单行文本" },
  { id: 2, name: "数字" },
  { id: 3, name: "日期" },
  { id: 6, name: "签约区" },
  { id: 11, name: "图" },
  { id: 20, name: "合同编号" },
  { id: 30, name: "下拉选择" },
  { id: 31, name: "复选框" },
  { id: 32, name: "身份证" },
  { id: 33, name: "手机号" }
];
//contract_template_dict.type
const templateDictType = [
  { id: 1, name: "账号(单独用)" },
  { id: 2, name: "证件类型" },
  { id: 3, name: "公司" },
  { id: 4, name: "家政服务类型" },
  { id: 5, name: "是否住家" },
  { id: 6, name: "雇佣解除情形" },
  { id: 7, name: "居间费支付方式" },
  { id: 8, name: "服务内容" },
  { id: 9, name: "报酬支付方式" },
];

const templateSignThreeType = [
  { id: 0, name: "没有" },
  { id: 1, name: "机构" },
  { id: 2, name: "个人" },
/*  { id: 3, name: "客户" },
  { id: 4, name: "其他" }*/
];
const isAutoSignList=[
  {
    id: 0,
    name: '是'
  },
  {
    id: 1,
    name: '否'
  }
];
export default {
    nationList,
    zodiacList,
    constellationList,
    birthplaceList,
    serviceModelList,
    templateNeedReview,
    templateLevel,
    templateSignOneType,
    templateSignTwoType,
    templateSignThreeType,
    templateKeyType,
    templateDictType,
    isAutoSignList
};
</script>
